import { render } from "./SortableCards.vue?vue&type=template&id=628ab9b8&ts=true"
import script from "./SortableCards.vue?vue&type=script&lang=ts"
export * from "./SortableCards.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__